import { render, staticRenderFns } from "./LafiaOptionItemExt.vue?vue&type=template&id=65251774&scoped=true"
import script from "./LafiaOptionItemExt.vue?vue&type=script&lang=js"
export * from "./LafiaOptionItemExt.vue?vue&type=script&lang=js"
import style0 from "./LafiaOptionItemExt.vue?vue&type=style&index=0&id=65251774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65251774",
  null
  
)

export default component.exports